// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Box from "../../resources/layout-and-structure/Box.res.js";
import * as Env from "../../core/Env.res.js";
import * as Auth from "../../bundles/Auth/Auth.res.js";
import * as I18n from "../../primitives/I18n.res.js";
import * as Json from "../../primitives/Json.res.js";
import * as Uuid from "../../externals/Uuid.res.js";
import * as Group from "../../resources/layout-and-structure/Group.res.js";
import * as Stack from "../../resources/layout-and-structure/Stack.res.js";
import * as React from "react";
import * as Button from "../../resources/actions/Button.res.js";
import * as Future from "rescript-future/src/Future.res.js";
import * as Inline from "../../resources/layout-and-structure/Inline.res.js";
import * as Offset from "../../resources/layout-and-structure/Offset.res.js";
import * as Request from "../../core/Request.res.js";
import * as Tooltip from "../../resources/overlays/Tooltip.res.js";
import * as AsyncData from "../../primitives/AsyncData.res.js";
import * as TextStyle from "../../resources/typography/TextStyle.res.js";
import * as Belt_Array from "@rescript/runtime/lib/es6/Belt_Array.js";
import * as HelpCenter from "../../core/HelpCenter.res.js";
import * as Navigation from "../../primitives/Navigation.res.js";
import * as TextAction from "../../resources/actions/TextAction.res.js";
import * as AsyncResult from "../../primitives/AsyncResult.res.js";
import * as Placeholder from "../../resources/layout-and-structure/Placeholder.res.js";
import * as TooltipIcon from "../../resources/overlays/TooltipIcon.res.js";
import * as Stdlib_Array from "@rescript/runtime/lib/es6/Stdlib_Array.js";
import * as FuturePromise from "rescript-future/src/FuturePromise.res.js";
import * as PaymentMethod from "../../modules/PaymentMethod.res.js";
import * as Stdlib_Option from "@rescript/runtime/lib/es6/Stdlib_Option.js";
import * as Client from "@apollo/client";
import * as InputTextField from "../../resources/selection-and-input/InputTextField.res.js";
import * as CanarySeparator from "../../resources/layout-and-structure/CanarySeparator.res.js";
import * as Primitive_float from "@rescript/runtime/lib/es6/Primitive_float.js";
import * as AccountingVendor from "../../modules/AccountingVendor.res.js";
import * as InputSelectField from "../../resources/selection-and-input/InputSelectField.res.js";
import * as Primitive_option from "@rescript/runtime/lib/es6/Primitive_option.js";
import * as JsxRuntime from "react/jsx-runtime";
import * as InputCheckboxField from "../../resources/selection-and-input/InputCheckboxField.res.js";
import * as FieldsetLayoutPanel from "../../resources/layout-and-structure/FieldsetLayoutPanel.res.js";
import * as ResourceDetailsPage from "../../core/ResourceDetailsPage.res.js";
import * as FiscalYearOpeningMonth from "../../modules/FiscalYearOpeningMonth.res.js";
import * as AccountingConfiguration from "../../modules/AccountingConfiguration.res.js";
import * as ReasonMLCommunity__ApolloClient from "rescript-apollo-client/src/ReasonMLCommunity__ApolloClient.res.js";
import * as ApolloClient__React_Hooks_UseQuery from "rescript-apollo-client/src/@apollo/client/react/hooks/ApolloClient__React_Hooks_UseQuery.res.js";

let shopAccountingConfigurationRequestBaseUrl = Env.gatewayUrl() + "/accounting-export-configurations/";

function createEndpoint() {
  return shopAccountingConfigurationRequestBaseUrl;
}

function updateEndpoint(shopId) {
  return shopAccountingConfigurationRequestBaseUrl + shopId;
}

function encodeBodyJson(value) {
  let isaComptaAccountNumber = value.isaComptaAccountNumber;
  let dict = Object.fromEntries([
    [
      "shopId",
      Json.encodeString(value.shopId)
    ],
    [
      "fiscalYearOpeningMonth",
      FiscalYearOpeningMonth.encodeToJson(value.fiscalYearOpeningMonth)
    ],
    [
      "isaComptaAccountNumber",
      isaComptaAccountNumber !== undefined ? Json.encodeString(isaComptaAccountNumber) : null
    ],
    [
      "accountingExportTaxAccounts",
      Json.encodeArray(value.taxesAccounts.map(v => AccountingConfiguration.TaxAccount.encodeToJson(v)))
    ],
    [
      "breakdownOfConsumerSalesByCashRegisterDailyReport",
      Json.encodeBoolean(value.breakdownOfConsumerSalesByCashRegisterDailyReport)
    ],
    [
      "includeCashFromIndividualsInPaymentJournal",
      Json.encodeBoolean(value.includeCashFromIndividualsInPaymentJournal)
    ]
  ]);
  let paymentsAccounts = value.maybePaymentsAccounts;
  if (paymentsAccounts !== undefined) {
    dict["accountingExportPaymentAccounts"] = Json.encodeArray(paymentsAccounts.map(v => AccountingConfiguration.PaymentAccount.encodeToJson(v)));
  }
  return Json.encodeDict(dict);
}

function make(getShopAccountingConfigurationRequest, value) {
  let bodyJson = {
    TAG: "JsonBody",
    _0: encodeBodyJson(value)
  };
  return Future.map(Future.flatMapOk(Future.flatMapOk(Future.mapError(getShopAccountingConfigurationRequest(value.shopId), undefined, () => {}), undefined, shopAccountingConfiguration => Future.mapError(shopAccountingConfiguration !== undefined ? Request.make(shopAccountingConfigurationRequestBaseUrl + value.shopId, "PATCH", bodyJson, undefined, undefined) : Request.make(shopAccountingConfigurationRequestBaseUrl, "POST", bodyJson, undefined, undefined), undefined, param => {})), undefined, param => getShopAccountingConfigurationRequest(value.shopId)), undefined, result => {
    if (result.TAG !== "Ok") {
      return {
        TAG: "Error",
        _0: undefined
      };
    }
    let response = result._0;
    if (response !== undefined) {
      return {
        TAG: "Ok",
        _0: Primitive_option.valFromOption(response)
      };
    } else {
      return {
        TAG: "Error",
        _0: undefined
      };
    }
  });
}

let CreateOrUpdateShopAccountingConfigurationRequest = {
  createEndpoint: createEndpoint,
  updateEndpoint: updateEndpoint,
  encodeBodyJson: encodeBodyJson,
  make: make
};

let Raw = {};

let query = Client.gql(["query QueryAllShopTaxes($filterBy: InputTaxQueryFilter)  {\ntaxes(filterBy: $filterBy)  {\n__typename  \nedges  {\n__typename  \nnode  {\n__typename  \nid  \nvalue  \n}\n\n}\n\n}\n\n}\n"]);

function parse(value) {
  let value$1 = value.taxes;
  let value$2 = value$1.edges;
  return {
    taxes: {
      __typename: value$1.__typename,
      edges: value$2.map(value => {
        let value$1 = value.node;
        return {
          __typename: value.__typename,
          node: {
            __typename: value$1.__typename,
            id: value$1.id,
            value: value$1.value
          }
        };
      })
    }
  };
}

function serialize(value) {
  let value$1 = value.taxes;
  let value$2 = value$1.edges;
  let edges = value$2.map(value => {
    let value$1 = value.node;
    let value$2 = value$1.value;
    let value$3 = value$1.id;
    let value$4 = value$1.__typename;
    let node = {
      __typename: value$4,
      id: value$3,
      value: value$2
    };
    let value$5 = value.__typename;
    return {
      __typename: value$5,
      node: node
    };
  });
  let value$3 = value$1.__typename;
  let taxes = {
    __typename: value$3,
    edges: edges
  };
  return {
    taxes: taxes
  };
}

function serializeInputObjectInFilter(inp) {
  let a = inp._in;
  return {
    _in: a.map(b => b)
  };
}

function serializeInputObjectInputTaxQueryFilter(inp) {
  let a = inp.archived;
  let a$1 = inp.shopIds;
  return {
    archived: a !== undefined ? (
        a === "ONLY" ? "ONLY" : (
            a === "INCLUDED" ? "INCLUDED" : "EXCLUDED"
          )
      ) : undefined,
    shopIds: a$1 !== undefined ? serializeInputObjectInFilter(a$1) : undefined
  };
}

function serializeVariables(inp) {
  let a = inp.filterBy;
  return {
    filterBy: a !== undefined ? serializeInputObjectInputTaxQueryFilter(a) : undefined
  };
}

function makeVariables(filterBy) {
  return {
    filterBy: filterBy
  };
}

function makeInputObjectInputTaxQueryFilter(archived, shopIds, param) {
  return {
    archived: archived,
    shopIds: shopIds
  };
}

function makeInputObjectInFilter(_in, param) {
  return {
    _in: _in
  };
}

function makeDefaultVariables() {
  return {
    filterBy: undefined
  };
}

let Query_inner = {
  Raw: Raw,
  query: query,
  parse: parse,
  serialize: serialize,
  serializeVariables: serializeVariables,
  serializeInputObjectInputTaxQueryFilter: serializeInputObjectInputTaxQueryFilter,
  serializeInputObjectInFilter: serializeInputObjectInFilter,
  makeVariables: makeVariables,
  makeInputObjectInputTaxQueryFilter: makeInputObjectInputTaxQueryFilter,
  makeInputObjectInFilter: makeInputObjectInFilter,
  makeDefaultVariables: makeDefaultVariables
};

let include = ApolloClient__React_Hooks_UseQuery.Extend({
  query: query,
  Raw: Raw,
  parse: parse,
  serialize: serialize,
  serializeVariables: serializeVariables
});

let Query_refetchQueryDescription = include.refetchQueryDescription;

let Query_use = include.use;

let Query_useLazy = include.useLazy;

let Query_useLazyWithVariables = include.useLazyWithVariables;

let Query = {
  Query_inner: Query_inner,
  Raw: Raw,
  query: query,
  parse: parse,
  serialize: serialize,
  serializeVariables: serializeVariables,
  serializeInputObjectInputTaxQueryFilter: serializeInputObjectInputTaxQueryFilter,
  serializeInputObjectInFilter: serializeInputObjectInFilter,
  makeVariables: makeVariables,
  makeInputObjectInputTaxQueryFilter: makeInputObjectInputTaxQueryFilter,
  makeInputObjectInFilter: makeInputObjectInFilter,
  makeDefaultVariables: makeDefaultVariables,
  refetchQueryDescription: Query_refetchQueryDescription,
  use: Query_use,
  useLazy: Query_useLazy,
  useLazyWithVariables: Query_useLazyWithVariables
};

function queryEdgesToItems(edges) {
  return Stdlib_Array.filterMap(edges, param => {
    let match = param.node;
    let value = match.value;
    return Stdlib_Option.map(Uuid.fromString(match.id), id => ({
      id: id,
      label: I18n.t("VAT rate") + " " + I18n.percentFormat(undefined, undefined, 1, value / 100),
      rate: value
    }));
  }).toSorted((param, param$1) => Primitive_float.compare(param$1.rate, param.rate));
}

function make$1(shopId, apolloClient) {
  return Future.map(FuturePromise.fromPromise(apolloClient.rescript_query({
    query: query,
    Raw: Raw,
    parse: parse,
    serialize: serialize,
    serializeVariables: serializeVariables
  }, undefined, undefined, "NetworkOnly", undefined, {
    filterBy: {
      archived: "EXCLUDED",
      shopIds: {
        _in: [shopId]
      }
    }
  })), undefined, value => {
    if (value.TAG !== "Ok") {
      return {
        TAG: "Error",
        _0: undefined
      };
    }
    let match = value._0;
    if (match.TAG === "Ok") {
      return {
        TAG: "Ok",
        _0: queryEdgesToItems(match._0.data.taxes.edges)
      };
    } else {
      return {
        TAG: "Error",
        _0: undefined
      };
    }
  });
}

let GetAllShopTaxesRequest = {
  Query: Query,
  queryEdgesToItems: queryEdgesToItems,
  make: make$1
};

function make$2(value) {
  return {
    value: value,
    touched: false,
    errorMessage: undefined
  };
}

function mapErrorMessage(param) {
  return param.errorMessage;
}

let nonEmptyStringErrorMessageStringLiteral = I18n.t("Please fulfill this field.");

let noDuplicateErrorMessageStringLiteral = I18n.t("This field must be unique; the value {{value}} has already been entered.");

let stringMinLengthErrorMessageStringLiteral = I18n.t("This field must contain {{length}} characters.");

let stringLengthErrorMessageStringLiteral = I18n.t("This field must contain between {{minLength}} and {{maxLength}} characters.");

let stringPatternErrorMessageStringLiteral = I18n.t("This field should be of format {{pattern}}.");

function validateNonEmptyStringValue(value) {
  if (value === "") {
    return nonEmptyStringErrorMessageStringLiteral;
  }
}

function validateNoDuplicate(value, duplicates) {
  if (duplicates.some(item => item === value)) {
    return I18n.template(noDuplicateErrorMessageStringLiteral, {
      value: value
    }, undefined);
  }
}

function valideNonEmptyStringLength(length, value) {
  if (value.length !== length) {
    return I18n.template(stringMinLengthErrorMessageStringLiteral, {
      length: length
    }, undefined);
  }
}

function validateStringLength(minLength, maxLength, value) {
  if (value.length >= minLength && value.length <= maxLength) {
    return;
  } else {
    return I18n.template(stringLengthErrorMessageStringLiteral, {
      minLength: minLength,
      maxLength: maxLength
    }, undefined);
  }
}

function errorMessageFromValidationRules(errors) {
  let errors$1 = errors.filter(Stdlib_Option.isSome);
  let error = errors$1[0];
  if (error !== undefined) {
    return Primitive_option.valFromOption(error);
  }
}

let FormField = {
  make: make$2,
  mapErrorMessage: mapErrorMessage,
  nonEmptyStringErrorMessageStringLiteral: nonEmptyStringErrorMessageStringLiteral,
  noDuplicateErrorMessageStringLiteral: noDuplicateErrorMessageStringLiteral,
  stringMinLengthErrorMessageStringLiteral: stringMinLengthErrorMessageStringLiteral,
  stringLengthErrorMessageStringLiteral: stringLengthErrorMessageStringLiteral,
  stringPatternErrorMessageStringLiteral: stringPatternErrorMessageStringLiteral,
  validateNonEmptyStringValue: validateNonEmptyStringValue,
  validateNoDuplicate: validateNoDuplicate,
  valideNonEmptyStringLength: valideNonEmptyStringLength,
  validateStringLength: validateStringLength,
  errorMessageFromValidationRules: errorMessageFromValidationRules
};

function fromUuid(value) {
  return value;
}

function unsafeFromString(prim) {
  return prim;
}

function toString(prim) {
  return prim;
}

function equal(a, b) {
  return a === b;
}

let ID = {
  fromUuid: fromUuid,
  unsafeFromString: unsafeFromString,
  toString: toString,
  equal: equal
};

function isDeductibleTax(taxRate) {
  return taxRate !== 0;
}

function isErrored(param) {
  let deductibleTaxFormFields = param.deductibleTaxFormFields;
  let productsSoldFormFields = param.productsSoldFormFields;
  if (Stdlib_Option.isSome(Stdlib_Option.flatMap(param.isaComptaCodeFormField, mapErrorMessage)) || Stdlib_Option.isSome(mapErrorMessage(productsSoldFormFields.accountNumberFormField)) || Stdlib_Option.isSome(mapErrorMessage(productsSoldFormFields.labelFormField)) || Stdlib_Option.isSome(Stdlib_Option.flatMap(deductibleTaxFormFields, param => mapErrorMessage(param.accountNumberFormField)))) {
    return true;
  } else {
    return Stdlib_Option.isSome(Stdlib_Option.flatMap(deductibleTaxFormFields, param => mapErrorMessage(param.labelFormField)));
  }
}

function isPristine(param) {
  let productsSoldFormFields = param.productsSoldFormFields;
  if (Stdlib_Option.mapOr(param.isaComptaCodeFormField, true, param => !param.touched) && !productsSoldFormFields.accountNumberFormField.touched && !productsSoldFormFields.labelFormField.touched) {
    return Stdlib_Option.mapOr(param.deductibleTaxFormFields, true, param => {
      if (param.accountNumberFormField.touched) {
        return false;
      } else {
        return !param.labelFormField.touched;
      }
    });
  } else {
    return false;
  }
}

function fillWithStandard(taxAccountFormFieldset, vendor) {
  let standardTaxAccount = AccountingConfiguration.TaxAccount.fillWithStandard(taxAccountFormFieldset.rate, taxAccountFormFieldset.id);
  let tmp;
  tmp = vendor === "Excel" ? undefined : Stdlib_Option.map(standardTaxAccount.isaComptaCode, value => ({
      value: value,
      touched: false,
      errorMessage: undefined
    }));
  let match = standardTaxAccount.productsSold;
  return {
    id: taxAccountFormFieldset.id,
    rate: taxAccountFormFieldset.rate,
    label: taxAccountFormFieldset.label,
    isaComptaCodeFormField: tmp,
    productsSoldFormFields: {
      accountNumberFormField: {
        value: match[0],
        touched: false,
        errorMessage: undefined
      },
      labelFormField: {
        value: match[1],
        touched: false,
        errorMessage: undefined
      }
    },
    deductibleTaxFormFields: taxAccountFormFieldset.rate !== 0 ? Stdlib_Option.map(standardTaxAccount.deductibleTax, param => ({
        accountNumberFormField: {
          value: param[0],
          touched: false,
          errorMessage: undefined
        },
        labelFormField: {
          value: param[1],
          touched: false,
          errorMessage: undefined
        }
      })) : undefined
  };
}

function changeFormFieldValue(fieldset, field, value) {
  let tmp;
  tmp = field === "IsaComptaCode" ? Stdlib_Option.map(fieldset.isaComptaCodeFormField, formField => ({
      value: value,
      touched: formField.touched,
      errorMessage: formField.errorMessage
    })) : fieldset.isaComptaCodeFormField;
  let formFields = fieldset.productsSoldFormFields;
  let tmp$1;
  if (field === "ProductsSoldAccountNumber") {
    let init = formFields.accountNumberFormField;
    tmp$1 = {
      value: value,
      touched: init.touched,
      errorMessage: init.errorMessage
    };
  } else {
    tmp$1 = formFields.accountNumberFormField;
  }
  let tmp$2;
  if (field === "ProductsSoldLabel") {
    let init$1 = formFields.labelFormField;
    tmp$2 = {
      value: value,
      touched: init$1.touched,
      errorMessage: init$1.errorMessage
    };
  } else {
    tmp$2 = formFields.labelFormField;
  }
  return {
    id: fieldset.id,
    rate: fieldset.rate,
    label: fieldset.label,
    isaComptaCodeFormField: tmp,
    productsSoldFormFields: {
      accountNumberFormField: tmp$1,
      labelFormField: tmp$2
    },
    deductibleTaxFormFields: Stdlib_Option.map(fieldset.deductibleTaxFormFields, formFields => {
      let tmp;
      if (field === "DeductibleTaxAccountNumber") {
        let init = formFields.accountNumberFormField;
        tmp = {
          value: value,
          touched: init.touched,
          errorMessage: init.errorMessage
        };
      } else {
        tmp = formFields.accountNumberFormField;
      }
      let tmp$1;
      if (field === "DeductibleTaxLabel") {
        let init$1 = formFields.labelFormField;
        tmp$1 = {
          value: value,
          touched: init$1.touched,
          errorMessage: init$1.errorMessage
        };
      } else {
        tmp$1 = formFields.labelFormField;
      }
      return {
        accountNumberFormField: tmp,
        labelFormField: tmp$1
      };
    })
  };
}

function blurFormField(fieldset, field) {
  let tmp;
  tmp = field === "IsaComptaCode" ? Stdlib_Option.map(fieldset.isaComptaCodeFormField, formField => ({
      value: formField.value,
      touched: true,
      errorMessage: formField.errorMessage
    })) : fieldset.isaComptaCodeFormField;
  let formFields = fieldset.productsSoldFormFields;
  let tmp$1;
  if (field === "ProductsSoldAccountNumber") {
    let init = formFields.accountNumberFormField;
    tmp$1 = {
      value: init.value,
      touched: true,
      errorMessage: init.errorMessage
    };
  } else {
    tmp$1 = formFields.accountNumberFormField;
  }
  let tmp$2;
  if (field === "ProductsSoldLabel") {
    let init$1 = formFields.labelFormField;
    tmp$2 = {
      value: init$1.value,
      touched: true,
      errorMessage: init$1.errorMessage
    };
  } else {
    tmp$2 = formFields.labelFormField;
  }
  return {
    id: fieldset.id,
    rate: fieldset.rate,
    label: fieldset.label,
    isaComptaCodeFormField: tmp,
    productsSoldFormFields: {
      accountNumberFormField: tmp$1,
      labelFormField: tmp$2
    },
    deductibleTaxFormFields: Stdlib_Option.map(fieldset.deductibleTaxFormFields, formFields => {
      let tmp;
      if (field === "DeductibleTaxAccountNumber") {
        let init = formFields.accountNumberFormField;
        tmp = {
          value: init.value,
          touched: true,
          errorMessage: init.errorMessage
        };
      } else {
        tmp = formFields.accountNumberFormField;
      }
      let tmp$1;
      if (field === "DeductibleTaxLabel") {
        let init$1 = formFields.labelFormField;
        tmp$1 = {
          value: init$1.value,
          touched: true,
          errorMessage: init$1.errorMessage
        };
      } else {
        tmp$1 = formFields.labelFormField;
      }
      return {
        accountNumberFormField: tmp,
        labelFormField: tmp$1
      };
    })
  };
}

function mapFormFieldValiation(value, accountNumberDuplicates, isaComptaCodesDuplicates) {
  let productsSoldFormFields = value.productsSoldFormFields;
  let isaComptaCodeFormField = value.isaComptaCodeFormField;
  let labelFormField = productsSoldFormFields.labelFormField;
  let accountNumberFormField = productsSoldFormFields.accountNumberFormField;
  return {
    id: value.id,
    rate: value.rate,
    label: value.label,
    isaComptaCodeFormField: isaComptaCodeFormField !== undefined ? ({
        value: isaComptaCodeFormField.value,
        touched: isaComptaCodeFormField.touched,
        errorMessage: errorMessageFromValidationRules([
          validateNonEmptyStringValue(isaComptaCodeFormField.value),
          validateStringLength(1, 2, isaComptaCodeFormField.value),
          validateNoDuplicate(isaComptaCodeFormField.value, isaComptaCodesDuplicates)
        ])
      }) : undefined,
    productsSoldFormFields: {
      accountNumberFormField: {
        value: accountNumberFormField.value,
        touched: accountNumberFormField.touched,
        errorMessage: errorMessageFromValidationRules([
          validateNoDuplicate(accountNumberFormField.value, accountNumberDuplicates),
          validateNonEmptyStringValue(accountNumberFormField.value)
        ])
      },
      labelFormField: {
        value: labelFormField.value,
        touched: labelFormField.touched,
        errorMessage: validateNonEmptyStringValue(labelFormField.value)
      }
    },
    deductibleTaxFormFields: Stdlib_Option.map(value.deductibleTaxFormFields, param => {
      let labelFormField = param.labelFormField;
      let accountNumberFormField = param.accountNumberFormField;
      return {
        accountNumberFormField: {
          value: accountNumberFormField.value,
          touched: accountNumberFormField.touched,
          errorMessage: errorMessageFromValidationRules([
            validateNonEmptyStringValue(accountNumberFormField.value),
            validateNoDuplicate(accountNumberFormField.value, accountNumberDuplicates)
          ])
        },
        labelFormField: {
          value: labelFormField.value,
          touched: labelFormField.touched,
          errorMessage: errorMessageFromValidationRules([validateNonEmptyStringValue(labelFormField.value)])
        }
      };
    })
  };
}

let TaxAccountFormFieldset = {
  ID: ID,
  isDeductibleTax: isDeductibleTax,
  isErrored: isErrored,
  isPristine: isPristine,
  fillWithStandard: fillWithStandard,
  changeFormFieldValue: changeFormFieldValue,
  blurFormField: blurFormField,
  mapFormFieldValiation: mapFormFieldValiation
};

function fromAccountingConfigurationPaymentAccount(param, vendor) {
  return {
    paymentMethod: param.paymentMethod,
    accountNumberFormField: {
      value: param.accountNumber,
      touched: false,
      errorMessage: undefined
    },
    accountLabelFormField: {
      value: param.accountLabel,
      touched: false,
      errorMessage: undefined
    },
    isaComptaJournalCodeFormField: AccountingVendor.isExcel(vendor) ? undefined : Stdlib_Option.mapOr(param.isaComptaJournalCode, {
        value: "",
        touched: false,
        errorMessage: undefined
      }, value => ({
        value: value,
        touched: false,
        errorMessage: undefined
      }))
  };
}

function make$3(paymentMethod, vendor) {
  let tmp;
  tmp = vendor === "Excel" ? undefined : ({
      value: "R1",
      touched: false,
      errorMessage: undefined
    });
  return {
    paymentMethod: paymentMethod,
    accountNumberFormField: {
      value: "",
      touched: false,
      errorMessage: undefined
    },
    accountLabelFormField: {
      value: I18n.template(I18n.t("Payment {{paymentMethod}}"), {
        paymentMethod: PaymentMethod.toLabel(paymentMethod)
      }, undefined),
      touched: false,
      errorMessage: undefined
    },
    isaComptaJournalCodeFormField: tmp
  };
}

function isPristine$1(param) {
  if (Stdlib_Option.mapOr(param.isaComptaJournalCodeFormField, true, param => !param.touched) && !param.accountNumberFormField.touched) {
    return !param.accountLabelFormField.touched;
  } else {
    return false;
  }
}

function isErrored$1(param) {
  if (Stdlib_Option.isSome(Stdlib_Option.flatMap(param.isaComptaJournalCodeFormField, mapErrorMessage)) || Stdlib_Option.isSome(mapErrorMessage(param.accountNumberFormField))) {
    return true;
  } else {
    return Stdlib_Option.isSome(mapErrorMessage(param.accountLabelFormField));
  }
}

function changeFormFieldValue$1(fieldset, field, value) {
  let tmp;
  switch (field) {
    case "AccountNumber" :
      let init = fieldset.accountNumberFormField;
      tmp = {
        value: value,
        touched: init.touched,
        errorMessage: init.errorMessage
      };
      break;
    case "AccountLabel" :
    case "IsaComptaJournalCode" :
      tmp = fieldset.accountNumberFormField;
      break;
  }
  let tmp$1;
  switch (field) {
    case "AccountLabel" :
      let init$1 = fieldset.accountLabelFormField;
      tmp$1 = {
        value: value,
        touched: init$1.touched,
        errorMessage: init$1.errorMessage
      };
      break;
    case "AccountNumber" :
    case "IsaComptaJournalCode" :
      tmp$1 = fieldset.accountLabelFormField;
      break;
  }
  let tmp$2;
  switch (field) {
    case "AccountNumber" :
    case "AccountLabel" :
      tmp$2 = fieldset.isaComptaJournalCodeFormField;
      break;
    case "IsaComptaJournalCode" :
      tmp$2 = Stdlib_Option.map(fieldset.isaComptaJournalCodeFormField, isaComptaJournalCodeFormField => ({
        value: value,
        touched: isaComptaJournalCodeFormField.touched,
        errorMessage: isaComptaJournalCodeFormField.errorMessage
      }));
      break;
  }
  return {
    paymentMethod: fieldset.paymentMethod,
    accountNumberFormField: tmp,
    accountLabelFormField: tmp$1,
    isaComptaJournalCodeFormField: tmp$2
  };
}

function blurFormField$1(fieldset, field) {
  let tmp;
  switch (field) {
    case "AccountNumber" :
      let init = fieldset.accountNumberFormField;
      tmp = {
        value: init.value,
        touched: true,
        errorMessage: init.errorMessage
      };
      break;
    case "AccountLabel" :
    case "IsaComptaJournalCode" :
      tmp = fieldset.accountNumberFormField;
      break;
  }
  let tmp$1;
  switch (field) {
    case "AccountLabel" :
      let init$1 = fieldset.accountLabelFormField;
      tmp$1 = {
        value: init$1.value,
        touched: true,
        errorMessage: init$1.errorMessage
      };
      break;
    case "AccountNumber" :
    case "IsaComptaJournalCode" :
      tmp$1 = fieldset.accountLabelFormField;
      break;
  }
  let tmp$2;
  switch (field) {
    case "AccountNumber" :
    case "AccountLabel" :
      tmp$2 = fieldset.isaComptaJournalCodeFormField;
      break;
    case "IsaComptaJournalCode" :
      tmp$2 = Stdlib_Option.map(fieldset.isaComptaJournalCodeFormField, formField => ({
        value: formField.value,
        touched: true,
        errorMessage: formField.errorMessage
      }));
      break;
  }
  return {
    paymentMethod: fieldset.paymentMethod,
    accountNumberFormField: tmp,
    accountLabelFormField: tmp$1,
    isaComptaJournalCodeFormField: tmp$2
  };
}

function validateIsaComptaCodeFormat(value) {
  if (/^R[0-9]$/.test(value)) {
    return;
  } else {
    return I18n.template(stringPatternErrorMessageStringLiteral, {
      pattern: "R0 à R9"
    }, undefined);
  }
}

function mapFormFieldValiation$1(param, accountNumberDuplicates, isaComptaCodesDuplicates) {
  let isaComptaJournalCodeFormField = param.isaComptaJournalCodeFormField;
  let accountLabelFormField = param.accountLabelFormField;
  let accountNumberFormField = param.accountNumberFormField;
  let accountNumberFormField_value = accountNumberFormField.value;
  let accountNumberFormField_touched = accountNumberFormField.touched;
  let accountNumberFormField_errorMessage = errorMessageFromValidationRules([
    validateNoDuplicate(accountNumberFormField.value, accountNumberDuplicates),
    validateNonEmptyStringValue(accountNumberFormField.value)
  ]);
  let accountNumberFormField$1 = {
    value: accountNumberFormField_value,
    touched: accountNumberFormField_touched,
    errorMessage: accountNumberFormField_errorMessage
  };
  let accountLabelFormField_value = accountLabelFormField.value;
  let accountLabelFormField_touched = accountLabelFormField.touched;
  let accountLabelFormField_errorMessage = validateNonEmptyStringValue(accountLabelFormField.value);
  let accountLabelFormField$1 = {
    value: accountLabelFormField_value,
    touched: accountLabelFormField_touched,
    errorMessage: accountLabelFormField_errorMessage
  };
  let isaComptaJournalCodeFormField$1 = isaComptaJournalCodeFormField !== undefined ? ({
      value: isaComptaJournalCodeFormField.value,
      touched: isaComptaJournalCodeFormField.touched,
      errorMessage: errorMessageFromValidationRules([
        validateNonEmptyStringValue(isaComptaJournalCodeFormField.value),
        valideNonEmptyStringLength(2, isaComptaJournalCodeFormField.value),
        validateIsaComptaCodeFormat(isaComptaJournalCodeFormField.value),
        validateNoDuplicate(isaComptaJournalCodeFormField.value, isaComptaCodesDuplicates)
      ])
    }) : undefined;
  return {
    paymentMethod: param.paymentMethod,
    accountNumberFormField: accountNumberFormField$1,
    accountLabelFormField: accountLabelFormField$1,
    isaComptaJournalCodeFormField: isaComptaJournalCodeFormField$1
  };
}

let PaymentAccountFormFieldset = {
  fromAccountingConfigurationPaymentAccount: fromAccountingConfigurationPaymentAccount,
  make: make$3,
  isPristine: isPristine$1,
  isErrored: isErrored$1,
  changeFormFieldValue: changeFormFieldValue$1,
  blurFormField: blurFormField$1,
  validateIsaComptaCodeFormat: validateIsaComptaCodeFormat,
  mapFormFieldValiation: mapFormFieldValiation$1
};

function isDataErrored(param) {
  if (Stdlib_Option.isSome(Stdlib_Option.flatMap(param.isaComptaAccountNumberFormField, param => param.errorMessage)) || param.taxesAccountsFormArrayFieldset.some(isErrored)) {
    return true;
  } else {
    return Stdlib_Option.mapOr(param.maybePaymentsAccountsFormArrayFieldset, false, paymentsAccountsFormArrayFieldset => paymentsAccountsFormArrayFieldset.some(isErrored$1));
  }
}

function findDuplicates(arr) {
  let seen = {};
  let duplicates = {};
  arr.forEach(value => {
    if (value === "") {
      return;
    }
    let match = seen[value];
    if (match !== undefined) {
      duplicates[value] = true;
    } else {
      seen[value] = true;
    }
  });
  return Object.keys(duplicates);
}

function mapDataFormFieldValiation(data) {
  let isaComptaAccountNumberFormField = data.isaComptaAccountNumberFormField;
  let isaComptaAccountNumberFormField$1 = isaComptaAccountNumberFormField !== undefined ? ({
      value: isaComptaAccountNumberFormField.value,
      touched: isaComptaAccountNumberFormField.touched,
      errorMessage: errorMessageFromValidationRules([validateNonEmptyStringValue(isaComptaAccountNumberFormField.value)])
    }) : undefined;
  let taxesAccountsIsaComptaCodes = Stdlib_Array.filterMap(data.taxesAccountsFormArrayFieldset, item => Stdlib_Option.map(item.isaComptaCodeFormField, f => f.value));
  let fieldSet = data.maybePaymentsAccountsFormArrayFieldset;
  let paymentsAccountsIsaComptaCodes = fieldSet !== undefined ? Stdlib_Array.filterMap(fieldSet, item => Stdlib_Option.map(item.isaComptaJournalCodeFormField, f => f.value)) : [];
  let taxesAccountsIsaComptaCodesDuplicates = findDuplicates(taxesAccountsIsaComptaCodes);
  let paymentsAccountsIsaComptaCodesDuplicates = findDuplicates(paymentsAccountsIsaComptaCodes);
  let deductibleTaxAccountNumbers = Stdlib_Array.filterMap(data.taxesAccountsFormArrayFieldset, item => Stdlib_Option.map(item.deductibleTaxFormFields, f => f.accountNumberFormField.value));
  let taxAccountNumbers = data.taxesAccountsFormArrayFieldset.map(item => item.productsSoldFormFields.accountNumberFormField.value);
  let paymentAccountNumbers = Stdlib_Option.getOr(Stdlib_Option.map(data.maybePaymentsAccountsFormArrayFieldset, paymentsAccountsFormArrayFieldset => paymentsAccountsFormArrayFieldset.map(paymentAccountFormFieldset => paymentAccountFormFieldset.accountNumberFormField.value)), []);
  let accountNumberDuplicates = findDuplicates(Belt_Array.concatMany([
    deductibleTaxAccountNumbers,
    taxAccountNumbers,
    paymentAccountNumbers
  ]));
  let taxesAccountsFormArrayFieldset = data.taxesAccountsFormArrayFieldset.map(fieldSet => mapFormFieldValiation(fieldSet, accountNumberDuplicates, taxesAccountsIsaComptaCodesDuplicates));
  let maybePaymentsAccountsFormArrayFieldset = Stdlib_Option.map(data.maybePaymentsAccountsFormArrayFieldset, paymentsAccountsFormArrayFieldset => paymentsAccountsFormArrayFieldset.map(fieldSet => mapFormFieldValiation$1(fieldSet, accountNumberDuplicates, paymentsAccountsIsaComptaCodesDuplicates)));
  return {
    submission: data.submission,
    initialAccountingConfiguration: data.initialAccountingConfiguration,
    vendor: data.vendor,
    fiscalYearOpeningMonth: data.fiscalYearOpeningMonth,
    breakdownOfConsumerSalesByCashRegisterDailyReport: data.breakdownOfConsumerSalesByCashRegisterDailyReport,
    includeCashFromIndividualsInPaymentJournal: data.includeCashFromIndividualsInPaymentJournal,
    isaComptaAccountNumberFormField: isaComptaAccountNumberFormField$1,
    taxesAccountsFormArrayFieldset: taxesAccountsFormArrayFieldset,
    maybePaymentsAccountsFormArrayFieldset: maybePaymentsAccountsFormArrayFieldset
  };
}

function isSubmitting(state) {
  if (typeof state !== "object") {
    return false;
  }
  if (state.TAG === "Reloading") {
    let match = state._0;
    if (match.TAG === "Ok") {
      return AsyncData.isBusy(match._0.submission);
    } else {
      return false;
    }
  }
  let match$1 = state._0;
  if (match$1.TAG === "Ok") {
    return AsyncData.isBusy(match$1._0.submission);
  } else {
    return false;
  }
}

function isPristine$2(state) {
  let data;
  if (typeof state !== "object") {
    return true;
  }
  if (state.TAG === "Reloading") {
    let data$1 = state._0;
    if (data$1.TAG !== "Ok") {
      return true;
    }
    data = data$1._0;
  } else {
    let data$2 = state._0;
    if (data$2.TAG !== "Ok") {
      return true;
    }
    data = data$2._0;
  }
  let initialAccountingConfiguration = data.initialAccountingConfiguration;
  let initialFiscalYearOpeningMonth = Stdlib_Option.mapOr(initialAccountingConfiguration, "January", param => param.fiscalYearOpeningMonth);
  let initialBreakdownOfConsumerSalesByCashRegisterDailyReport = Stdlib_Option.mapOr(initialAccountingConfiguration, true, param => param.breakdownOfConsumerSalesByCashRegisterDailyReport);
  let initialIncludeCashFromIndividualsInPaymentJournal = Stdlib_Option.mapOr(initialAccountingConfiguration, true, param => param.includeCashFromIndividualsInPaymentJournal);
  if (FiscalYearOpeningMonth.isEqual(initialFiscalYearOpeningMonth, data.fiscalYearOpeningMonth) && data.breakdownOfConsumerSalesByCashRegisterDailyReport === initialBreakdownOfConsumerSalesByCashRegisterDailyReport && data.includeCashFromIndividualsInPaymentJournal === initialIncludeCashFromIndividualsInPaymentJournal && Stdlib_Option.mapOr(data.isaComptaAccountNumberFormField, true, param => !param.touched) && data.taxesAccountsFormArrayFieldset.every(isPristine)) {
    return Stdlib_Option.mapOr(data.maybePaymentsAccountsFormArrayFieldset, true, paymentsAccountsFormArrayFieldset => paymentsAccountsFormArrayFieldset.every(isPristine$1));
  } else {
    return false;
  }
}

function hasBeenSubmitted(state) {
  if (typeof state !== "object") {
    return false;
  }
  if (state.TAG === "Reloading") {
    let match = state._0;
    if (match.TAG !== "Ok") {
      return false;
    }
    let tmp = match._0.submission;
    if (typeof tmp !== "object") {
      return false;
    } else {
      return tmp.TAG === "Done";
    }
  }
  let match$1 = state._0;
  if (match$1.TAG !== "Ok") {
    return false;
  }
  let tmp$1 = match$1._0.submission;
  if (typeof tmp$1 !== "object") {
    return false;
  } else {
    return tmp$1.TAG === "Done";
  }
}

function initialState() {
  return AsyncData.notAsked();
}

function initialStateDataFromOkResult(vendor, allShopTaxes, accountingConfiguration, param) {
  let tmp;
  if (vendor === "Excel") {
    tmp = undefined;
  } else if (accountingConfiguration !== undefined) {
    let value = Stdlib_Option.getOr(accountingConfiguration.isaComptaAccountNumber, "");
    tmp = {
      value: value,
      touched: false,
      errorMessage: undefined
    };
  } else {
    tmp = {
      value: "",
      touched: false,
      errorMessage: undefined
    };
  }
  return {
    submission: AsyncResult.notAsked(),
    initialAccountingConfiguration: accountingConfiguration,
    vendor: vendor,
    fiscalYearOpeningMonth: Stdlib_Option.mapOr(accountingConfiguration, "January", param => param.fiscalYearOpeningMonth),
    breakdownOfConsumerSalesByCashRegisterDailyReport: Stdlib_Option.mapOr(accountingConfiguration, true, param => param.breakdownOfConsumerSalesByCashRegisterDailyReport),
    includeCashFromIndividualsInPaymentJournal: Stdlib_Option.mapOr(accountingConfiguration, false, param => param.includeCashFromIndividualsInPaymentJournal),
    isaComptaAccountNumberFormField: tmp,
    taxesAccountsFormArrayFieldset: allShopTaxes.map(shopTax => {
      let shopTaxId = shopTax.id;
      let initialTaxAccount = Stdlib_Option.flatMap(accountingConfiguration, param => param.taxesAccounts.find(param => param.taxId === shopTaxId));
      if (initialTaxAccount === undefined) {
        return {
          id: shopTaxId,
          rate: shopTax.rate,
          label: shopTax.label,
          isaComptaCodeFormField: AccountingVendor.isIsaCompta(vendor) ? ({
              value: "",
              touched: false,
              errorMessage: undefined
            }) : undefined,
          productsSoldFormFields: {
            accountNumberFormField: {
              value: "",
              touched: false,
              errorMessage: undefined
            },
            labelFormField: {
              value: "",
              touched: false,
              errorMessage: undefined
            }
          },
          deductibleTaxFormFields: shopTax.rate !== 0 ? ({
              accountNumberFormField: {
                value: "",
                touched: false,
                errorMessage: undefined
              },
              labelFormField: {
                value: "",
                touched: false,
                errorMessage: undefined
              }
            }) : undefined
        };
      }
      let tmp;
      if (AccountingVendor.isIsaCompta(vendor)) {
        let value = Stdlib_Option.getOr(initialTaxAccount.isaComptaCode, "");
        tmp = {
          value: value,
          touched: false,
          errorMessage: undefined
        };
      } else {
        tmp = undefined;
      }
      let match = initialTaxAccount.productsSold;
      let tmp$1;
      if (shopTax.rate !== 0) {
        let match$1 = initialTaxAccount.deductibleTax;
        tmp$1 = match$1 !== undefined ? ({
            accountNumberFormField: {
              value: match$1[0],
              touched: false,
              errorMessage: undefined
            },
            labelFormField: {
              value: match$1[1],
              touched: false,
              errorMessage: undefined
            }
          }) : ({
            accountNumberFormField: {
              value: "",
              touched: false,
              errorMessage: undefined
            },
            labelFormField: {
              value: "",
              touched: false,
              errorMessage: undefined
            }
          });
      } else {
        tmp$1 = undefined;
      }
      return {
        id: shopTaxId,
        rate: shopTax.rate,
        label: shopTax.label,
        isaComptaCodeFormField: tmp,
        productsSoldFormFields: {
          accountNumberFormField: {
            value: match[0],
            touched: false,
            errorMessage: undefined
          },
          labelFormField: {
            value: match[1],
            touched: false,
            errorMessage: undefined
          }
        },
        deductibleTaxFormFields: tmp$1
      };
    }),
    maybePaymentsAccountsFormArrayFieldset: Stdlib_Option.map(Stdlib_Option.flatMap(accountingConfiguration, param => param.maybePaymentsAccounts), paymentsAccounts => paymentsAccounts.map(paymentAccount => fromAccountingConfigurationPaymentAccount(paymentAccount, vendor)))
  };
}

function initialStateFromOkResult(vendor, allShopTaxes, accountingConfiguration, param) {
  return AsyncResult.doneOk(initialStateDataFromOkResult(vendor, allShopTaxes, accountingConfiguration, undefined));
}

function make$4(state, action) {
  let tmp;
  let exit = 0;
  if (typeof action !== "object") {
    switch (action) {
      case "AsyncDataLoading" :
        tmp = AsyncResult.toBusy(state);
        break;
      case "AsyncDataDoneError" :
        tmp = AsyncResult.done({
          TAG: "Error",
          _0: undefined
        });
        break;
      default:
        exit = 1;
    }
  } else if (action.TAG === "AsyncDataDoneOk") {
    tmp = initialStateFromOkResult(action.vendor, action.allShopTaxes, action.accountingConfiguration, undefined);
  } else {
    exit = 1;
  }
  if (exit === 1) {
    tmp = AsyncResult.mapOk(state, data => {
      if (typeof action !== "object") {
        switch (action) {
          case "SubmitButtonClicked" :
            return {
              submission: "Loading",
              initialAccountingConfiguration: data.initialAccountingConfiguration,
              vendor: data.vendor,
              fiscalYearOpeningMonth: data.fiscalYearOpeningMonth,
              breakdownOfConsumerSalesByCashRegisterDailyReport: data.breakdownOfConsumerSalesByCashRegisterDailyReport,
              includeCashFromIndividualsInPaymentJournal: data.includeCashFromIndividualsInPaymentJournal,
              isaComptaAccountNumberFormField: data.isaComptaAccountNumberFormField,
              taxesAccountsFormArrayFieldset: data.taxesAccountsFormArrayFieldset,
              maybePaymentsAccountsFormArrayFieldset: data.maybePaymentsAccountsFormArrayFieldset
            };
          case "NotificationBannerCloseButtonClicked" :
            return {
              submission: "NotAsked",
              initialAccountingConfiguration: data.initialAccountingConfiguration,
              vendor: data.vendor,
              fiscalYearOpeningMonth: data.fiscalYearOpeningMonth,
              breakdownOfConsumerSalesByCashRegisterDailyReport: data.breakdownOfConsumerSalesByCashRegisterDailyReport,
              includeCashFromIndividualsInPaymentJournal: data.includeCashFromIndividualsInPaymentJournal,
              isaComptaAccountNumberFormField: data.isaComptaAccountNumberFormField,
              taxesAccountsFormArrayFieldset: data.taxesAccountsFormArrayFieldset,
              maybePaymentsAccountsFormArrayFieldset: data.maybePaymentsAccountsFormArrayFieldset
            };
          case "AutoCompleteWithStandardTaxesAccounts" :
            return {
              submission: data.submission,
              initialAccountingConfiguration: data.initialAccountingConfiguration,
              vendor: data.vendor,
              fiscalYearOpeningMonth: data.fiscalYearOpeningMonth,
              breakdownOfConsumerSalesByCashRegisterDailyReport: data.breakdownOfConsumerSalesByCashRegisterDailyReport,
              includeCashFromIndividualsInPaymentJournal: data.includeCashFromIndividualsInPaymentJournal,
              isaComptaAccountNumberFormField: data.isaComptaAccountNumberFormField,
              taxesAccountsFormArrayFieldset: data.taxesAccountsFormArrayFieldset.map(taxAccountFormFieldset => fillWithStandard(taxAccountFormFieldset, data.vendor)),
              maybePaymentsAccountsFormArrayFieldset: data.maybePaymentsAccountsFormArrayFieldset
            };
          case "IsaComptaAccountNumberFormFieldBlured" :
            return {
              submission: data.submission,
              initialAccountingConfiguration: data.initialAccountingConfiguration,
              vendor: data.vendor,
              fiscalYearOpeningMonth: data.fiscalYearOpeningMonth,
              breakdownOfConsumerSalesByCashRegisterDailyReport: data.breakdownOfConsumerSalesByCashRegisterDailyReport,
              includeCashFromIndividualsInPaymentJournal: data.includeCashFromIndividualsInPaymentJournal,
              isaComptaAccountNumberFormField: Stdlib_Option.map(data.isaComptaAccountNumberFormField, field => ({
                value: field.value,
                touched: true,
                errorMessage: field.errorMessage
              })),
              taxesAccountsFormArrayFieldset: data.taxesAccountsFormArrayFieldset,
              maybePaymentsAccountsFormArrayFieldset: data.maybePaymentsAccountsFormArrayFieldset
            };
          case "PaymentsAccountsFormArrayFieldsetToggled" :
            let match = data.maybePaymentsAccountsFormArrayFieldset;
            return {
              submission: data.submission,
              initialAccountingConfiguration: data.initialAccountingConfiguration,
              vendor: data.vendor,
              fiscalYearOpeningMonth: data.fiscalYearOpeningMonth,
              breakdownOfConsumerSalesByCashRegisterDailyReport: data.breakdownOfConsumerSalesByCashRegisterDailyReport,
              includeCashFromIndividualsInPaymentJournal: data.includeCashFromIndividualsInPaymentJournal,
              isaComptaAccountNumberFormField: data.isaComptaAccountNumberFormField,
              taxesAccountsFormArrayFieldset: data.taxesAccountsFormArrayFieldset,
              maybePaymentsAccountsFormArrayFieldset: match !== undefined ? undefined : []
            };
          case "AutocompleteBasicPaymentsAccounts" :
            let vendor = data.vendor;
            return {
              submission: data.submission,
              initialAccountingConfiguration: data.initialAccountingConfiguration,
              vendor: data.vendor,
              fiscalYearOpeningMonth: data.fiscalYearOpeningMonth,
              breakdownOfConsumerSalesByCashRegisterDailyReport: data.breakdownOfConsumerSalesByCashRegisterDailyReport,
              includeCashFromIndividualsInPaymentJournal: data.includeCashFromIndividualsInPaymentJournal,
              isaComptaAccountNumberFormField: data.isaComptaAccountNumberFormField,
              taxesAccountsFormArrayFieldset: data.taxesAccountsFormArrayFieldset,
              maybePaymentsAccountsFormArrayFieldset: AccountingConfiguration.autocompleteBasicPaymentsAccounts(vendor).map(paymentAccount => fromAccountingConfigurationPaymentAccount(paymentAccount, vendor))
            };
          case "PaymentsAccountsFormFieldsetAdded" :
            return {
              submission: data.submission,
              initialAccountingConfiguration: data.initialAccountingConfiguration,
              vendor: data.vendor,
              fiscalYearOpeningMonth: data.fiscalYearOpeningMonth,
              breakdownOfConsumerSalesByCashRegisterDailyReport: data.breakdownOfConsumerSalesByCashRegisterDailyReport,
              includeCashFromIndividualsInPaymentJournal: data.includeCashFromIndividualsInPaymentJournal,
              isaComptaAccountNumberFormField: data.isaComptaAccountNumberFormField,
              taxesAccountsFormArrayFieldset: data.taxesAccountsFormArrayFieldset,
              maybePaymentsAccountsFormArrayFieldset: Stdlib_Option.map(data.maybePaymentsAccountsFormArrayFieldset, paymentsAccountsFormFieldset => {
                let nextPaymentMethods = PaymentMethod.values.filter(value => Stdlib_Option.isNone(paymentsAccountsFormFieldset.find(param => PaymentMethod.equal(param.paymentMethod, value))));
                let nextPaymentMethod = nextPaymentMethods[0];
                if (nextPaymentMethod !== undefined) {
                  return Belt_Array.concatMany([
                    paymentsAccountsFormFieldset,
                    [make$3(nextPaymentMethod, data.vendor)]
                  ]);
                } else {
                  return paymentsAccountsFormFieldset;
                }
              })
            };
          default:
            return data;
        }
      } else {
        switch (action.TAG) {
          case "SubmissionSucceeded" :
            let init = initialStateDataFromOkResult(action.vendor, action.allShopTaxes, action.accountingConfiguration, undefined);
            return {
              submission: {
                TAG: "Done",
                _0: {
                  TAG: "Ok",
                  _0: undefined
                }
              },
              initialAccountingConfiguration: init.initialAccountingConfiguration,
              vendor: init.vendor,
              fiscalYearOpeningMonth: init.fiscalYearOpeningMonth,
              breakdownOfConsumerSalesByCashRegisterDailyReport: init.breakdownOfConsumerSalesByCashRegisterDailyReport,
              includeCashFromIndividualsInPaymentJournal: init.includeCashFromIndividualsInPaymentJournal,
              isaComptaAccountNumberFormField: init.isaComptaAccountNumberFormField,
              taxesAccountsFormArrayFieldset: init.taxesAccountsFormArrayFieldset,
              maybePaymentsAccountsFormArrayFieldset: init.maybePaymentsAccountsFormArrayFieldset
            };
          case "SubmissionFailed" :
            return {
              submission: {
                TAG: "Done",
                _0: {
                  TAG: "Error",
                  _0: action._0
                }
              },
              initialAccountingConfiguration: data.initialAccountingConfiguration,
              vendor: data.vendor,
              fiscalYearOpeningMonth: data.fiscalYearOpeningMonth,
              breakdownOfConsumerSalesByCashRegisterDailyReport: data.breakdownOfConsumerSalesByCashRegisterDailyReport,
              includeCashFromIndividualsInPaymentJournal: data.includeCashFromIndividualsInPaymentJournal,
              isaComptaAccountNumberFormField: data.isaComptaAccountNumberFormField,
              taxesAccountsFormArrayFieldset: data.taxesAccountsFormArrayFieldset,
              maybePaymentsAccountsFormArrayFieldset: data.maybePaymentsAccountsFormArrayFieldset
            };
          case "VendorChanged" :
            let vendor$1 = action._0;
            let tmp;
            tmp = vendor$1 === "Excel" ? undefined : ({
                value: "",
                touched: false,
                errorMessage: undefined
              });
            return {
              submission: data.submission,
              initialAccountingConfiguration: data.initialAccountingConfiguration,
              vendor: vendor$1,
              fiscalYearOpeningMonth: data.fiscalYearOpeningMonth,
              breakdownOfConsumerSalesByCashRegisterDailyReport: data.breakdownOfConsumerSalesByCashRegisterDailyReport,
              includeCashFromIndividualsInPaymentJournal: data.includeCashFromIndividualsInPaymentJournal,
              isaComptaAccountNumberFormField: tmp,
              taxesAccountsFormArrayFieldset: data.taxesAccountsFormArrayFieldset.map(taxAccount => {
                let tmp;
                tmp = vendor$1 === "Excel" ? undefined : ({
                    value: "",
                    touched: false,
                    errorMessage: undefined
                  });
                return {
                  id: taxAccount.id,
                  rate: taxAccount.rate,
                  label: taxAccount.label,
                  isaComptaCodeFormField: tmp,
                  productsSoldFormFields: taxAccount.productsSoldFormFields,
                  deductibleTaxFormFields: taxAccount.deductibleTaxFormFields
                };
              }),
              maybePaymentsAccountsFormArrayFieldset: Stdlib_Option.map(data.maybePaymentsAccountsFormArrayFieldset, paymentsAccountsFormArrayFieldset => paymentsAccountsFormArrayFieldset.map(paymentAccountFormFieldset => {
                let tmp;
                tmp = vendor$1 === "Excel" ? undefined : ({
                    value: "",
                    touched: false,
                    errorMessage: undefined
                  });
                return {
                  paymentMethod: paymentAccountFormFieldset.paymentMethod,
                  accountNumberFormField: paymentAccountFormFieldset.accountNumberFormField,
                  accountLabelFormField: paymentAccountFormFieldset.accountLabelFormField,
                  isaComptaJournalCodeFormField: tmp
                };
              }))
            };
          case "FiscalYearOpeningMonthChanged" :
            return {
              submission: data.submission,
              initialAccountingConfiguration: data.initialAccountingConfiguration,
              vendor: data.vendor,
              fiscalYearOpeningMonth: action._0,
              breakdownOfConsumerSalesByCashRegisterDailyReport: data.breakdownOfConsumerSalesByCashRegisterDailyReport,
              includeCashFromIndividualsInPaymentJournal: data.includeCashFromIndividualsInPaymentJournal,
              isaComptaAccountNumberFormField: data.isaComptaAccountNumberFormField,
              taxesAccountsFormArrayFieldset: data.taxesAccountsFormArrayFieldset,
              maybePaymentsAccountsFormArrayFieldset: data.maybePaymentsAccountsFormArrayFieldset
            };
          case "IsaComptaAccountNumberFormFieldChanged" :
            let value = action._0;
            return {
              submission: data.submission,
              initialAccountingConfiguration: data.initialAccountingConfiguration,
              vendor: data.vendor,
              fiscalYearOpeningMonth: data.fiscalYearOpeningMonth,
              breakdownOfConsumerSalesByCashRegisterDailyReport: data.breakdownOfConsumerSalesByCashRegisterDailyReport,
              includeCashFromIndividualsInPaymentJournal: data.includeCashFromIndividualsInPaymentJournal,
              isaComptaAccountNumberFormField: Stdlib_Option.map(data.isaComptaAccountNumberFormField, field => ({
                value: value,
                touched: field.touched,
                errorMessage: field.errorMessage
              })),
              taxesAccountsFormArrayFieldset: data.taxesAccountsFormArrayFieldset,
              maybePaymentsAccountsFormArrayFieldset: data.maybePaymentsAccountsFormArrayFieldset
            };
          case "BreakdownOfConsumerSalesByCashRegisterDailyReportChanged" :
            return {
              submission: data.submission,
              initialAccountingConfiguration: data.initialAccountingConfiguration,
              vendor: data.vendor,
              fiscalYearOpeningMonth: data.fiscalYearOpeningMonth,
              breakdownOfConsumerSalesByCashRegisterDailyReport: action._0,
              includeCashFromIndividualsInPaymentJournal: data.includeCashFromIndividualsInPaymentJournal,
              isaComptaAccountNumberFormField: data.isaComptaAccountNumberFormField,
              taxesAccountsFormArrayFieldset: data.taxesAccountsFormArrayFieldset,
              maybePaymentsAccountsFormArrayFieldset: data.maybePaymentsAccountsFormArrayFieldset
            };
          case "IncludeCashFromIndividualsInPaymentJournalChanged" :
            return {
              submission: data.submission,
              initialAccountingConfiguration: data.initialAccountingConfiguration,
              vendor: data.vendor,
              fiscalYearOpeningMonth: data.fiscalYearOpeningMonth,
              breakdownOfConsumerSalesByCashRegisterDailyReport: data.breakdownOfConsumerSalesByCashRegisterDailyReport,
              includeCashFromIndividualsInPaymentJournal: action._0,
              isaComptaAccountNumberFormField: data.isaComptaAccountNumberFormField,
              taxesAccountsFormArrayFieldset: data.taxesAccountsFormArrayFieldset,
              maybePaymentsAccountsFormArrayFieldset: data.maybePaymentsAccountsFormArrayFieldset
            };
          case "TaxAccountFormFieldChanged" :
            let value$1 = action._2;
            let field = action._1;
            let id = action._0;
            return {
              submission: data.submission,
              initialAccountingConfiguration: data.initialAccountingConfiguration,
              vendor: data.vendor,
              fiscalYearOpeningMonth: data.fiscalYearOpeningMonth,
              breakdownOfConsumerSalesByCashRegisterDailyReport: data.breakdownOfConsumerSalesByCashRegisterDailyReport,
              includeCashFromIndividualsInPaymentJournal: data.includeCashFromIndividualsInPaymentJournal,
              isaComptaAccountNumberFormField: data.isaComptaAccountNumberFormField,
              taxesAccountsFormArrayFieldset: data.taxesAccountsFormArrayFieldset.map(taxAccountFormFielset => {
                if (id === taxAccountFormFielset.id) {
                  return changeFormFieldValue(taxAccountFormFielset, field, value$1);
                } else {
                  return taxAccountFormFielset;
                }
              }),
              maybePaymentsAccountsFormArrayFieldset: data.maybePaymentsAccountsFormArrayFieldset
            };
          case "TaxAccountFormFieldBlured" :
            let field$1 = action._1;
            let id$1 = action._0;
            return {
              submission: data.submission,
              initialAccountingConfiguration: data.initialAccountingConfiguration,
              vendor: data.vendor,
              fiscalYearOpeningMonth: data.fiscalYearOpeningMonth,
              breakdownOfConsumerSalesByCashRegisterDailyReport: data.breakdownOfConsumerSalesByCashRegisterDailyReport,
              includeCashFromIndividualsInPaymentJournal: data.includeCashFromIndividualsInPaymentJournal,
              isaComptaAccountNumberFormField: data.isaComptaAccountNumberFormField,
              taxesAccountsFormArrayFieldset: data.taxesAccountsFormArrayFieldset.map(taxAccountFormFielset => {
                if (id$1 === taxAccountFormFielset.id) {
                  return blurFormField(taxAccountFormFielset, field$1);
                } else {
                  return taxAccountFormFielset;
                }
              }),
              maybePaymentsAccountsFormArrayFieldset: data.maybePaymentsAccountsFormArrayFieldset
            };
          case "PaymentsAccountsFormFieldsetRemoved" :
            let paymentMethod = action._0;
            return {
              submission: data.submission,
              initialAccountingConfiguration: data.initialAccountingConfiguration,
              vendor: data.vendor,
              fiscalYearOpeningMonth: data.fiscalYearOpeningMonth,
              breakdownOfConsumerSalesByCashRegisterDailyReport: data.breakdownOfConsumerSalesByCashRegisterDailyReport,
              includeCashFromIndividualsInPaymentJournal: data.includeCashFromIndividualsInPaymentJournal,
              isaComptaAccountNumberFormField: data.isaComptaAccountNumberFormField,
              taxesAccountsFormArrayFieldset: data.taxesAccountsFormArrayFieldset,
              maybePaymentsAccountsFormArrayFieldset: Stdlib_Option.map(data.maybePaymentsAccountsFormArrayFieldset, paymentsAccountsFormFieldset => paymentsAccountsFormFieldset.filter(payementAccountArrayFieldset => payementAccountArrayFieldset.paymentMethod !== paymentMethod))
            };
          case "PaymentAccountFormFieldChanged" :
            let value$2 = action._2;
            let field$2 = action._1;
            let activePaymentMethod = action._0;
            return {
              submission: data.submission,
              initialAccountingConfiguration: data.initialAccountingConfiguration,
              vendor: data.vendor,
              fiscalYearOpeningMonth: data.fiscalYearOpeningMonth,
              breakdownOfConsumerSalesByCashRegisterDailyReport: data.breakdownOfConsumerSalesByCashRegisterDailyReport,
              includeCashFromIndividualsInPaymentJournal: data.includeCashFromIndividualsInPaymentJournal,
              isaComptaAccountNumberFormField: data.isaComptaAccountNumberFormField,
              taxesAccountsFormArrayFieldset: data.taxesAccountsFormArrayFieldset,
              maybePaymentsAccountsFormArrayFieldset: Stdlib_Option.map(data.maybePaymentsAccountsFormArrayFieldset, paymentsAccountsFormArrayFieldset => paymentsAccountsFormArrayFieldset.map(paymentAccountFormFieldset => {
                if (PaymentMethod.equal(paymentAccountFormFieldset.paymentMethod, activePaymentMethod)) {
                  return changeFormFieldValue$1(paymentAccountFormFieldset, field$2, value$2);
                } else {
                  return paymentAccountFormFieldset;
                }
              }))
            };
          case "PaymentAccountFormFieldBlured" :
            let field$3 = action._1;
            let activePaymentMethod$1 = action._0;
            return {
              submission: data.submission,
              initialAccountingConfiguration: data.initialAccountingConfiguration,
              vendor: data.vendor,
              fiscalYearOpeningMonth: data.fiscalYearOpeningMonth,
              breakdownOfConsumerSalesByCashRegisterDailyReport: data.breakdownOfConsumerSalesByCashRegisterDailyReport,
              includeCashFromIndividualsInPaymentJournal: data.includeCashFromIndividualsInPaymentJournal,
              isaComptaAccountNumberFormField: data.isaComptaAccountNumberFormField,
              taxesAccountsFormArrayFieldset: data.taxesAccountsFormArrayFieldset,
              maybePaymentsAccountsFormArrayFieldset: Stdlib_Option.map(data.maybePaymentsAccountsFormArrayFieldset, paymentsAccountsFormArrayFieldset => paymentsAccountsFormArrayFieldset.map(paymentAccountFormFieldset => {
                if (PaymentMethod.equal(paymentAccountFormFieldset.paymentMethod, activePaymentMethod$1)) {
                  return blurFormField$1(paymentAccountFormFieldset, field$3);
                } else {
                  return paymentAccountFormFieldset;
                }
              }))
            };
          case "PaymentAccountPaymentMethodChanged" :
            let nextPaymentMethod = action.next;
            let previous = action.previous;
            return {
              submission: data.submission,
              initialAccountingConfiguration: data.initialAccountingConfiguration,
              vendor: data.vendor,
              fiscalYearOpeningMonth: data.fiscalYearOpeningMonth,
              breakdownOfConsumerSalesByCashRegisterDailyReport: data.breakdownOfConsumerSalesByCashRegisterDailyReport,
              includeCashFromIndividualsInPaymentJournal: data.includeCashFromIndividualsInPaymentJournal,
              isaComptaAccountNumberFormField: data.isaComptaAccountNumberFormField,
              taxesAccountsFormArrayFieldset: data.taxesAccountsFormArrayFieldset,
              maybePaymentsAccountsFormArrayFieldset: Stdlib_Option.map(data.maybePaymentsAccountsFormArrayFieldset, paymentsAccountsFormArrayFieldset => paymentsAccountsFormArrayFieldset.map(paymentAccountFormFieldset => {
                if (PaymentMethod.equal(previous, paymentAccountFormFieldset.paymentMethod)) {
                  return make$3(nextPaymentMethod, data.vendor);
                } else {
                  return paymentAccountFormFieldset;
                }
              }))
            };
          default:
            return data;
        }
      }
    });
  }
  return AsyncResult.mapOk(tmp, mapDataFormFieldValiation);
}

let Reducer = {
  isDataErrored: isDataErrored,
  findDuplicates: findDuplicates,
  mapDataFormFieldValiation: mapDataFormFieldValiation,
  isSubmitting: isSubmitting,
  isPristine: isPristine$2,
  hasBeenSubmitted: hasBeenSubmitted,
  initialState: initialState,
  initialStateDataFromOkResult: initialStateDataFromOkResult,
  initialStateFromOkResult: initialStateFromOkResult,
  make: make$4
};

function mapReducerValuesAndShopIdToAccountingConfiguration(shopId, values) {
  return {
    shopId: shopId,
    isaComptaAccountNumber: Stdlib_Option.map(values.isaComptaAccountNumberFormField, param => param.value),
    fiscalYearOpeningMonth: values.fiscalYearOpeningMonth,
    taxesAccounts: values.taxesAccountsFormArrayFieldset.map(taxAccountFormFieldset => {
      let match = taxAccountFormFieldset.productsSoldFormFields;
      return {
        taxId: taxAccountFormFieldset.id,
        isaComptaCode: Stdlib_Option.map(taxAccountFormFieldset.isaComptaCodeFormField, param => param.value),
        productsSold: [
          match.accountNumberFormField.value,
          match.labelFormField.value
        ],
        deductibleTax: Stdlib_Option.map(taxAccountFormFieldset.deductibleTaxFormFields, param => [
          param.accountNumberFormField.value,
          param.labelFormField.value
        ])
      };
    }),
    maybePaymentsAccounts: Stdlib_Option.map(values.maybePaymentsAccountsFormArrayFieldset, paymentsAccountsFormArrayFieldset => paymentsAccountsFormArrayFieldset.map(paymentAccountFormFieldset => ({
      paymentMethod: paymentAccountFormFieldset.paymentMethod,
      accountNumber: paymentAccountFormFieldset.accountNumberFormField.value,
      accountLabel: paymentAccountFormFieldset.accountLabelFormField.value,
      isaComptaJournalCode: Stdlib_Option.map(paymentAccountFormFieldset.isaComptaJournalCodeFormField, param => param.value)
    }))),
    breakdownOfConsumerSalesByCashRegisterDailyReport: values.breakdownOfConsumerSalesByCashRegisterDailyReport,
    includeCashFromIndividualsInPaymentJournal: values.includeCashFromIndividualsInPaymentJournal
  };
}

function AccountingConfigurationPage(props) {
  let vendor = props.vendor;
  let shopId = props.shopId;
  let baseRoute = props.baseRoute;
  let configurationRoute = props.configurationRoute;
  let createOrUpdateShopAccountingConfigurationRequest = props.createOrUpdateShopAccountingConfigurationRequest;
  let getShopAccountingConfigurationRequest = props.getShopAccountingConfigurationRequest;
  let getAllShopTaxesRequest = props.getAllShopTaxesRequest;
  let apolloClient = ReasonMLCommunity__ApolloClient.React.useApolloClient();
  let navigate = Navigation.useNavigate();
  let shops = Auth.useShops();
  let shop = Stdlib_Option.getExn(shops.find(shop => shop.id === shopId), undefined);
  let match = React.useReducer(make$4, AsyncData.notAsked());
  let dispatch = match[1];
  let state = match[0];
  let submitting = isSubmitting(state);
  let isPristine$3 = isPristine$2(state);
  let hasBeenSubmitted$1 = hasBeenSubmitted(state) && !isPristine$3;
  let handleLoadAsyncData = shopId => {
    dispatch("AsyncDataLoading");
    let futures = Future.all2([
      getAllShopTaxesRequest(shopId, apolloClient),
      getShopAccountingConfigurationRequest(shopId)
    ]);
    Future.get(futures, param => {
      let shopAccountingConfiguration = param[1];
      let allShopTaxes = param[0];
      if (shopAccountingConfiguration.TAG !== "Ok") {
        return dispatch("AsyncDataDoneError");
      }
      if (allShopTaxes.TAG !== "Ok") {
        return;
      }
      let accountingConfiguration = shopAccountingConfiguration._0;
      let allShopTaxes$1 = allShopTaxes._0;
      if (accountingConfiguration !== undefined) {
        return dispatch({
          TAG: "AsyncDataDoneOk",
          vendor: vendor,
          allShopTaxes: allShopTaxes$1,
          accountingConfiguration: accountingConfiguration
        });
      } else {
        return dispatch({
          TAG: "AsyncDataDoneOk",
          vendor: "Excel",
          allShopTaxes: allShopTaxes$1
        });
      }
    });
    return futures;
  };
  React.useEffect(() => {
    let future = handleLoadAsyncData(shopId);
    return () => Future.cancel(future);
  }, []);
  React.useEffect(() => {
    if (submitting) {
      if (typeof state !== "object" || state.TAG !== "Done") {
        dispatch({
          TAG: "SubmissionFailed",
          _0: I18n.t("An unexpected error occured. Please try again or contact the support.")
        });
      } else {
        let data = state._0;
        if (data.TAG === "Ok") {
          let data$1 = data._0;
          if (isDataErrored(data$1)) {
            dispatch({
              TAG: "SubmissionFailed",
              _0: I18n.t("There are some errors in the form, please correct them before trying to send it again.")
            });
          } else {
            Future.get(Future.all2([
              getAllShopTaxesRequest(shopId, apolloClient),
              createOrUpdateShopAccountingConfigurationRequest(getShopAccountingConfigurationRequest, mapReducerValuesAndShopIdToAccountingConfiguration(shopId, data$1))
            ]), result => {
              let allShopTaxes = result[0];
              if (allShopTaxes.TAG !== "Ok") {
                return dispatch({
                  TAG: "SubmissionFailed",
                  _0: I18n.t("An unexpected error occured. Please try again or contact the support.")
                });
              }
              let accountingConfiguration = result[1];
              if (accountingConfiguration.TAG === "Ok") {
                return dispatch({
                  TAG: "SubmissionSucceeded",
                  vendor: vendor,
                  allShopTaxes: allShopTaxes._0,
                  accountingConfiguration: accountingConfiguration._0
                });
              } else {
                return dispatch({
                  TAG: "SubmissionFailed",
                  _0: I18n.t("An unexpected error occured. Please try again or contact the support.")
                });
              }
            });
          }
        } else {
          dispatch({
            TAG: "SubmissionFailed",
            _0: I18n.t("An unexpected error occured. Please try again or contact the support.")
          });
        }
      }
    }
  }, [submitting]);
  let activeVendor;
  if (typeof state !== "object") {
    activeVendor = undefined;
  } else if (state.TAG === "Reloading") {
    let match$1 = state._0;
    activeVendor = match$1.TAG === "Ok" ? match$1._0.vendor : undefined;
  } else {
    let match$2 = state._0;
    activeVendor = match$2.TAG === "Ok" ? match$2._0.vendor : undefined;
  }
  React.useEffect(() => {
    if (activeVendor !== undefined && !AccountingVendor.equal(vendor, activeVendor)) {
      navigate(undefined, configurationRoute(shopId, activeVendor));
    }
  }, [activeVendor]);
  let titlePage = I18n.t("Setup my accounting accounts");
  let titleSubtitle = shop.name;
  let exit = 0;
  let values;
  if (typeof state !== "object") {
    exit = 2;
  } else if (state.TAG === "Reloading") {
    let values$1 = state._0;
    if (values$1.TAG === "Ok") {
      values = values$1._0;
      exit = 1;
    } else {
      exit = 2;
    }
  } else {
    let values$2 = state._0;
    if (values$2.TAG !== "Ok") {
      return JsxRuntime.jsx(ResourceDetailsPage.make, {
        title: titlePage,
        subtitle: titleSubtitle,
        children: JsxRuntime.jsx(Placeholder.make, {
          status: "Error"
        })
      });
    }
    values = values$2._0;
    exit = 1;
  }
  switch (exit) {
    case 1 :
      let handleSubmit = param => dispatch("SubmitButtonClicked");
      let actionsBar = JsxRuntime.jsx(ResourceDetailsPage.ActionsBar.make, {
        items: [
          isPristine$3 ? JsxRuntime.jsx(Button.make, {
              label: I18n.t("Return to export interface"),
              onPress: () => navigate(undefined, baseRoute)
            }) : JsxRuntime.jsx(Button.make, {
              label: I18n.t("Cancel"),
              onPress: () => {
                handleLoadAsyncData(shopId);
              }
            }),
          JsxRuntime.jsx(Button.make, {
            label: I18n.t("Save"),
            variant: "solid",
            tone: "success",
            pending: submitting,
            onPress: handleSubmit
          })
        ]
      });
      let onRequestCloseNotificationBanner = () => dispatch("NotificationBannerCloseButtonClicked");
      let match$3 = values.submission;
      let notificationBanner;
      if (typeof match$3 !== "object" || match$3.TAG !== "Done") {
        notificationBanner = null;
      } else {
        let errorMessage = match$3._0;
        notificationBanner = errorMessage.TAG === "Ok" ? JsxRuntime.jsx(ResourceDetailsPage.NotificationBanner.make, {
            value: {
              TAG: "Ok",
              _0: I18n.t("The configuration has been successfully saved")
            },
            onRequestClose: onRequestCloseNotificationBanner
          }) : JsxRuntime.jsx(ResourceDetailsPage.NotificationBanner.make, {
            value: {
              TAG: "Error",
              _0: errorMessage._0
            },
            onRequestClose: onRequestCloseNotificationBanner
          });
      }
      let match$4 = values.isaComptaAccountNumberFormField;
      let paymentsAccountsFormArrayFieldset = values.maybePaymentsAccountsFormArrayFieldset;
      return JsxRuntime.jsx(ResourceDetailsPage.make, {
        title: titlePage,
        subtitle: titleSubtitle,
        actionsBar: actionsBar,
        notificationBanner: notificationBanner,
        children: JsxRuntime.jsxs(Stack.make, {
          children: [
            JsxRuntime.jsxs(FieldsetLayoutPanel.make, {
              title: I18n.t("accounting_configuration.settings_general.title"),
              description: I18n.t("accounting_configuration.settings_general.description"),
              children: [
                JsxRuntime.jsx(InputSelectField.make, {
                  label: I18n.t("Format"),
                  required: true,
                  onChange: value => dispatch({
                    TAG: "VendorChanged",
                    _0: value
                  }),
                  value: values.vendor,
                  sections: [{
                      items: AccountingVendor.values.map(AccountingVendor.toSelectItem)
                    }]
                }),
                JsxRuntime.jsxs(Group.make, {
                  children: [
                    match$4 !== undefined ? JsxRuntime.jsx(InputTextField.make, {
                        label: I18n.t("IsaCompta file number"),
                        errorMessage: match$4.touched || hasBeenSubmitted$1 ? match$4.errorMessage : undefined,
                        value: match$4.value,
                        onChange: value => dispatch({
                          TAG: "IsaComptaAccountNumberFormFieldChanged",
                          _0: value
                        }),
                        onBlur: () => dispatch("IsaComptaAccountNumberFormFieldBlured")
                      }) : null,
                    JsxRuntime.jsx(InputSelectField.make, {
                      label: I18n.t("Fiscal year (per month of opening)"),
                      required: true,
                      onChange: value => dispatch({
                        TAG: "FiscalYearOpeningMonthChanged",
                        _0: value
                      }),
                      searchable: false,
                      value: values.fiscalYearOpeningMonth,
                      sections: [{
                          items: FiscalYearOpeningMonth.values.map(FiscalYearOpeningMonth.toSelectItem)
                        }]
                    })
                  ]
                }),
                JsxRuntime.jsx(InputCheckboxField.make, {
                  label: I18n.t("Breakdown of sales to consumers"),
                  text: I18n.t("Display of daily cash register reports instead of receipts"),
                  value: !values.breakdownOfConsumerSalesByCashRegisterDailyReport,
                  onChange: value => dispatch({
                    TAG: "BreakdownOfConsumerSalesByCashRegisterDailyReportChanged",
                    _0: !value
                  })
                })
              ]
            }),
            JsxRuntime.jsxs(FieldsetLayoutPanel.make, {
              title: I18n.t("accounting_configuration.setting_tax_rates.title"),
              description: I18n.t("accounting_configuration.setting_tax_rates.description"),
              children: [
                Stdlib_Option.isNone(values.initialAccountingConfiguration) ? JsxRuntime.jsxs(Box.make, {
                    children: [
                      JsxRuntime.jsxs(Stack.make, {
                        children: [
                          JsxRuntime.jsx(TextStyle.make, {
                            children: I18n.t("accounting.configuration_page.help_with_accouting_standard"),
                            size: "small"
                          }),
                          JsxRuntime.jsx(Button.make, {
                            label: I18n.t("Autocomplete with accounting standard"),
                            variant: "solid",
                            tone: "brand",
                            size: "small",
                            onPress: () => dispatch("AutoCompleteWithStandardTaxesAccounts")
                          })
                        ],
                        space: "normal",
                        align: "start"
                      }),
                      JsxRuntime.jsx(CanarySeparator.make, {
                        orientation: "horizontal"
                      }),
                      JsxRuntime.jsx(TextAction.make, {
                        text: I18n.t("Learn more about accounting entries"),
                        onPress: () => HelpCenter.showArticle("setupAndExportAccountingEntries")
                      })
                    ],
                    spaceBottom: "medium"
                  }) : null,
                JsxRuntime.jsx(InputTextField.make, {
                  label: I18n.t("Journal code"),
                  required: true,
                  disabled: true,
                  value: "VE"
                }),
                JsxRuntime.jsx(CanarySeparator.make, {
                  orientation: "horizontal",
                  spacing: "tiny"
                }),
                values.taxesAccountsFormArrayFieldset.map((param, index) => {
                  let deductibleTaxFormFields = param.deductibleTaxFormFields;
                  let productsSoldFormFields = param.productsSoldFormFields;
                  let isaComptaCodeFormField = param.isaComptaCodeFormField;
                  let id = param.id;
                  let tmp;
                  if (deductibleTaxFormFields !== undefined) {
                    let match = deductibleTaxFormFields.accountNumberFormField;
                    tmp = JsxRuntime.jsx(InputTextField.make, {
                      label: I18n.t("Tax account"),
                      required: true,
                      errorMessage: match.touched || hasBeenSubmitted$1 ? match.errorMessage : undefined,
                      value: match.value,
                      onChange: value => dispatch({
                        TAG: "TaxAccountFormFieldChanged",
                        _0: id,
                        _1: "DeductibleTaxAccountNumber",
                        _2: value
                      }),
                      onBlur: () => dispatch({
                        TAG: "TaxAccountFormFieldBlured",
                        _0: id,
                        _1: "DeductibleTaxAccountNumber"
                      })
                    });
                  } else {
                    tmp = JsxRuntime.jsx(InputTextField.make, {
                      label: I18n.t("Tax account"),
                      disabled: true,
                      placeholder: I18n.t("Non-deductible VAT"),
                      value: ""
                    });
                  }
                  let tmp$1;
                  if (deductibleTaxFormFields !== undefined) {
                    let match$1 = deductibleTaxFormFields.labelFormField;
                    tmp$1 = JsxRuntime.jsx(InputTextField.make, {
                      label: I18n.t("Associated label"),
                      required: true,
                      errorMessage: match$1.touched || hasBeenSubmitted$1 ? match$1.errorMessage : undefined,
                      value: match$1.value,
                      onChange: value => dispatch({
                        TAG: "TaxAccountFormFieldChanged",
                        _0: id,
                        _1: "DeductibleTaxLabel",
                        _2: value
                      }),
                      onBlur: () => dispatch({
                        TAG: "TaxAccountFormFieldBlured",
                        _0: id,
                        _1: "DeductibleTaxLabel"
                      })
                    });
                  } else {
                    tmp$1 = JsxRuntime.jsx(InputTextField.make, {
                      label: I18n.t("Associated label"),
                      disabled: true
                    });
                  }
                  let match$2 = productsSoldFormFields.accountNumberFormField;
                  let match$3 = productsSoldFormFields.labelFormField;
                  return JsxRuntime.jsxs(React.Fragment, {
                    children: [
                      JsxRuntime.jsxs(Stack.make, {
                        children: [
                          JsxRuntime.jsxs(Inline.make, {
                            children: [
                              JsxRuntime.jsx(TextStyle.make, {
                                children: param.label + " ",
                                weight: "semibold"
                              }),
                              Stdlib_Option.isNone(deductibleTaxFormFields) ? JsxRuntime.jsx(Offset.make, {
                                  children: JsxRuntime.jsx(TooltipIcon.make, {
                                    children: JsxRuntime.jsx(Tooltip.Span.make, {
                                      text: I18n.t("Used for overseas sales")
                                    }),
                                    variation: "alert",
                                    crossOffset: -2
                                  }),
                                  top: -1,
                                  height: 13
                                }) : null
                            ],
                            space: "xsmall"
                          }),
                          JsxRuntime.jsxs(Group.make, {
                            children: [
                              tmp,
                              tmp$1,
                              JsxRuntime.jsx(InputTextField.make, {
                                label: I18n.t("Goods account"),
                                required: true,
                                errorMessage: match$2.touched || hasBeenSubmitted$1 ? match$2.errorMessage : undefined,
                                value: match$2.value,
                                onChange: value => dispatch({
                                  TAG: "TaxAccountFormFieldChanged",
                                  _0: id,
                                  _1: "ProductsSoldAccountNumber",
                                  _2: value
                                }),
                                onBlur: () => dispatch({
                                  TAG: "TaxAccountFormFieldBlured",
                                  _0: id,
                                  _1: "ProductsSoldAccountNumber"
                                })
                              }),
                              JsxRuntime.jsx(InputTextField.make, {
                                label: I18n.t("Associated label"),
                                required: true,
                                errorMessage: match$3.touched || hasBeenSubmitted$1 ? match$3.errorMessage : undefined,
                                value: match$3.value,
                                onChange: value => dispatch({
                                  TAG: "TaxAccountFormFieldChanged",
                                  _0: id,
                                  _1: "ProductsSoldLabel",
                                  _2: value
                                }),
                                onBlur: () => dispatch({
                                  TAG: "TaxAccountFormFieldBlured",
                                  _0: id,
                                  _1: "ProductsSoldLabel"
                                })
                              }),
                              isaComptaCodeFormField !== undefined ? JsxRuntime.jsx(InputTextField.make, {
                                  label: I18n.t("IsaCompta code"),
                                  required: true,
                                  errorMessage: isaComptaCodeFormField.touched || hasBeenSubmitted$1 ? isaComptaCodeFormField.errorMessage : undefined,
                                  value: isaComptaCodeFormField.value,
                                  onChange: value => dispatch({
                                    TAG: "TaxAccountFormFieldChanged",
                                    _0: id,
                                    _1: "IsaComptaCode",
                                    _2: value
                                  }),
                                  onBlur: () => dispatch({
                                    TAG: "TaxAccountFormFieldBlured",
                                    _0: id,
                                    _1: "IsaComptaCode"
                                  })
                                }) : null
                            ]
                          })
                        ],
                        space: "small"
                      }),
                      index < (values.taxesAccountsFormArrayFieldset.length - 1 | 0) ? JsxRuntime.jsx(CanarySeparator.make, {
                          orientation: "horizontal",
                          spacing: "tiny"
                        }) : null
                    ]
                  }, id);
                })
              ]
            }),
            JsxRuntime.jsxs(FieldsetLayoutPanel.make, {
              title: I18n.t("accounting_configuration.setting_payments.title"),
              description: I18n.t("accounting_configuration.setting_payments.description"),
              children: [
                JsxRuntime.jsx(InputCheckboxField.make, {
                  label: "",
                  text: I18n.t("If checked, the payment journal will be exported."),
                  value: Stdlib_Option.isSome(values.maybePaymentsAccountsFormArrayFieldset),
                  onChange: param => dispatch("PaymentsAccountsFormArrayFieldsetToggled")
                }),
                paymentsAccountsFormArrayFieldset !== undefined ? JsxRuntime.jsxs(JsxRuntime.Fragment, {
                    children: [
                      paymentsAccountsFormArrayFieldset.length === 0 ? JsxRuntime.jsx(Box.make, {
                          children: JsxRuntime.jsxs(Stack.make, {
                            children: [
                              JsxRuntime.jsx(TextStyle.make, {
                                children: I18n.t("accounting.configuration_page.setting_payments.help_with_autocomplete"),
                                size: "small"
                              }),
                              JsxRuntime.jsx(Button.make, {
                                label: I18n.t("Autocomplete"),
                                variant: "solid",
                                tone: "brand",
                                size: "small",
                                onPress: () => dispatch("AutocompleteBasicPaymentsAccounts")
                              })
                            ],
                            space: "normal",
                            align: "start"
                          }),
                          spaceBottom: "medium"
                        }) : null,
                      AccountingVendor.isExcel(values.vendor) ? JsxRuntime.jsx(InputTextField.make, {
                          label: I18n.t("Journal code"),
                          required: true,
                          disabled: true,
                          value: "RE"
                        }) : null,
                      JsxRuntime.jsx(CanarySeparator.make, {
                        orientation: "horizontal",
                        spacing: "tiny"
                      }),
                      paymentsAccountsFormArrayFieldset.map((param, index) => {
                        let isaComptaJournalCodeFormField = param.isaComptaJournalCodeFormField;
                        let accountLabelFormField = param.accountLabelFormField;
                        let accountNumberFormField = param.accountNumberFormField;
                        let paymentMethod = param.paymentMethod;
                        let match = values.includeCashFromIndividualsInPaymentJournal;
                        let tmp;
                        tmp = paymentMethod === "Cash" && match ? JsxRuntime.jsx(Tooltip.Span.make, {
                            text: I18n.t("accounting_configuration.setting_payments.cash_accounting_account_tooltip")
                          }) : undefined;
                        let tmp$1;
                        if (isaComptaJournalCodeFormField !== undefined) {
                          let match$1 = values.includeCashFromIndividualsInPaymentJournal;
                          let tmp$2;
                          tmp$2 = paymentMethod === "Cash" && match$1 ? JsxRuntime.jsx(Tooltip.Span.make, {
                              text: I18n.t("accounting_configuration.setting_payments.isacompta_journal_code_tooltip")
                            }) : undefined;
                          tmp$1 = JsxRuntime.jsx(InputTextField.make, {
                            label: I18n.t("IsaCompta journal code"),
                            required: true,
                            tooltip: tmp$2,
                            errorMessage: isaComptaJournalCodeFormField.touched || hasBeenSubmitted$1 ? isaComptaJournalCodeFormField.errorMessage : undefined,
                            value: isaComptaJournalCodeFormField.value,
                            onChange: value => dispatch({
                              TAG: "PaymentAccountFormFieldChanged",
                              _0: paymentMethod,
                              _1: "IsaComptaJournalCode",
                              _2: value
                            }),
                            onBlur: () => dispatch({
                              TAG: "PaymentAccountFormFieldBlured",
                              _0: paymentMethod,
                              _1: "IsaComptaJournalCode"
                            })
                          });
                        } else {
                          tmp$1 = null;
                        }
                        return JsxRuntime.jsxs(React.Fragment, {
                          children: [
                            JsxRuntime.jsxs(Group.make, {
                              children: [
                                JsxRuntime.jsx(InputSelectField.make, {
                                  label: I18n.t("Payment method"),
                                  onChange: value => dispatch({
                                    TAG: "PaymentAccountPaymentMethodChanged",
                                    previous: paymentMethod,
                                    next: value
                                  }),
                                  value: paymentMethod,
                                  sections: [{
                                      items: PaymentMethod.values.filter(value => {
                                        if (PaymentMethod.equal(paymentMethod, value)) {
                                          return true;
                                        } else {
                                          return Stdlib_Option.isNone(paymentsAccountsFormArrayFieldset.find(param => PaymentMethod.equal(param.paymentMethod, value)));
                                        }
                                      }).map(value => ({
                                        TAG: "Option",
                                        key: PaymentMethod.toLabel(value),
                                        label: PaymentMethod.toLabel(value),
                                        value: value
                                      }))
                                    }]
                                }),
                                JsxRuntime.jsx(InputTextField.make, {
                                  label: I18n.t("Accounting account"),
                                  required: true,
                                  tooltip: tmp,
                                  errorMessage: accountNumberFormField.touched || hasBeenSubmitted$1 ? accountNumberFormField.errorMessage : undefined,
                                  value: accountNumberFormField.value,
                                  onChange: value => dispatch({
                                    TAG: "PaymentAccountFormFieldChanged",
                                    _0: paymentMethod,
                                    _1: "AccountNumber",
                                    _2: value
                                  }),
                                  onBlur: () => dispatch({
                                    TAG: "PaymentAccountFormFieldBlured",
                                    _0: paymentMethod,
                                    _1: "AccountNumber"
                                  })
                                }),
                                JsxRuntime.jsx(InputTextField.make, {
                                  label: I18n.t("Associated label"),
                                  required: true,
                                  errorMessage: accountLabelFormField.touched || hasBeenSubmitted$1 ? accountLabelFormField.errorMessage : undefined,
                                  value: accountLabelFormField.value,
                                  onChange: value => dispatch({
                                    TAG: "PaymentAccountFormFieldChanged",
                                    _0: paymentMethod,
                                    _1: "AccountLabel",
                                    _2: value
                                  }),
                                  onBlur: () => dispatch({
                                    TAG: "PaymentAccountFormFieldBlured",
                                    _0: paymentMethod,
                                    _1: "AccountLabel"
                                  })
                                }),
                                tmp$1,
                                JsxRuntime.jsx(Box.make, {
                                  children: JsxRuntime.jsx(Button.make, {
                                    shape: "pill",
                                    icon: "delete",
                                    onPress: () => dispatch({
                                      TAG: "PaymentsAccountsFormFieldsetRemoved",
                                      _0: paymentMethod
                                    })
                                  }),
                                  spaceTop: "large"
                                })
                              ],
                              grid: AccountingVendor.isExcel(values.vendor) ? [
                                  "28%",
                                  "28%",
                                  "28%",
                                  "auto"
                                ] : [
                                  "22%",
                                  "22%",
                                  "22%",
                                  "22%",
                                  "auto"
                                ]
                            }),
                            index < (paymentsAccountsFormArrayFieldset.length - 1 | 0) ? JsxRuntime.jsx(CanarySeparator.make, {
                                orientation: "horizontal",
                                spacing: "tiny"
                              }) : null
                          ]
                        }, PaymentMethod.toLabel(paymentMethod) + index.toString());
                      }),
                      JsxRuntime.jsx(Inline.make, {
                        children: JsxRuntime.jsx(Button.make, {
                          label: I18n.t("Add"),
                          variant: "subtle",
                          disabled: PaymentMethod.values.filter(value => Stdlib_Option.isNone(paymentsAccountsFormArrayFieldset.find(param => PaymentMethod.equal(param.paymentMethod, value)))).length === 0,
                          icon: "plus_small",
                          onPress: () => dispatch("PaymentsAccountsFormFieldsetAdded")
                        }),
                        grow: false
                      })
                    ]
                  }) : null
              ]
            }),
            JsxRuntime.jsxs(FieldsetLayoutPanel.make, {
              title: I18n.t("accounting_configuration.setting_cashflow.title"),
              description: I18n.t("accounting_configuration.setting_cashflow.description"),
              children: [
                JsxRuntime.jsx(InputCheckboxField.make, {
                  label: I18n.t("Cash payments in payments journal"),
                  text: I18n.t("If this option is checked, cash payments will be recorded in the cash journal.\n Otherwise it will be recorded in the payments journal."),
                  value: !values.includeCashFromIndividualsInPaymentJournal,
                  onChange: value => dispatch({
                    TAG: "IncludeCashFromIndividualsInPaymentJournalChanged",
                    _0: !value
                  })
                }),
                JsxRuntime.jsx(CanarySeparator.make, {
                  orientation: "horizontal",
                  spacing: "tiny"
                }),
                JsxRuntime.jsx(InputTextField.make, {
                  label: I18n.t("Journal code"),
                  required: true,
                  tooltip: JsxRuntime.jsx(Tooltip.Span.make, {
                    text: I18n.t("accounting_configuration.setting_cashflow.journal_code.tooltip")
                  }),
                  disabled: true,
                  value: "Cx"
                }),
                JsxRuntime.jsx(CanarySeparator.make, {
                  orientation: "horizontal",
                  spacing: "tiny"
                }),
                JsxRuntime.jsxs(Group.make, {
                  children: [
                    JsxRuntime.jsx(InputTextField.make, {
                      label: I18n.t("Cash flow accounting account"),
                      required: true,
                      disabled: true,
                      value: "53000000"
                    }),
                    JsxRuntime.jsx(InputTextField.make, {
                      label: I18n.t("Cash flow label account"),
                      required: true,
                      disabled: true,
                      value: "Caisse"
                    })
                  ]
                }),
                JsxRuntime.jsxs(Group.make, {
                  children: [
                    JsxRuntime.jsx(InputTextField.make, {
                      label: I18n.t("Internal transfer account"),
                      required: true,
                      tooltip: JsxRuntime.jsx(Tooltip.Span.make, {
                        text: I18n.t("accounting_configuration.setting_cashflow.internal_transfer_account.tooltip")
                      }),
                      disabled: true,
                      value: "58000000"
                    }),
                    JsxRuntime.jsx(InputTextField.make, {
                      label: I18n.t("Internal transfer label account"),
                      required: true,
                      disabled: true,
                      value: "Virements internes"
                    })
                  ]
                }),
                JsxRuntime.jsxs(Group.make, {
                  children: [
                    JsxRuntime.jsx(InputTextField.make, {
                      label: I18n.t("Negative cash difference account"),
                      required: true,
                      disabled: true,
                      value: "65800000"
                    }),
                    JsxRuntime.jsx(InputTextField.make, {
                      label: I18n.t("Negative cash difference label account"),
                      required: true,
                      disabled: true,
                      value: "Charges div-gestion courante"
                    })
                  ]
                }),
                JsxRuntime.jsxs(Group.make, {
                  children: [
                    JsxRuntime.jsx(InputTextField.make, {
                      label: I18n.t("Positive cash difference account"),
                      required: true,
                      disabled: true,
                      value: "75800000"
                    }),
                    JsxRuntime.jsx(InputTextField.make, {
                      label: I18n.t("Positive cash difference label account"),
                      required: true,
                      disabled: true,
                      value: "Produits div-gestion courante"
                    })
                  ]
                })
              ]
            })
          ],
          space: "large"
        })
      });
    case 2 :
      return JsxRuntime.jsx(ResourceDetailsPage.make, {
        title: titlePage,
        subtitle: titleSubtitle,
        children: JsxRuntime.jsx(Placeholder.make, {
          status: "Loading"
        })
      });
  }
}

let getAllShopTaxesRequest = make$1;

let createOrUpdateShopAccountingConfigurationRequest = make;

let make$5 = AccountingConfigurationPage;

export {
  shopAccountingConfigurationRequestBaseUrl,
  CreateOrUpdateShopAccountingConfigurationRequest,
  GetAllShopTaxesRequest,
  FormField,
  TaxAccountFormFieldset,
  PaymentAccountFormFieldset,
  Reducer,
  getAllShopTaxesRequest,
  createOrUpdateShopAccountingConfigurationRequest,
  mapReducerValuesAndShopIdToAccountingConfiguration,
  make$5 as make,
}
/* shopAccountingConfigurationRequestBaseUrl Not a pure module */
